import { IPaymentMethods } from '../../common/models/orderData';

export type PaymentMethod = IPaymentMethods;
export type PaymentMethodLeaf = IPaymentMethods & { id: number };
export type PaymentMethodWithGateway = IPaymentMethods & { gatewayID: number };

export const isGroup = (item: PaymentMethod): boolean => {
  const tp = (item.type || '').toLowerCase();
  return tp === 'paymentmethodgroup' || tp === 'paymentmethodsgroup';
};

export const hasId = (item: PaymentMethod): item is PaymentMethodLeaf =>
  typeof (item as any).id === 'number' && !Number.isNaN((item as any).id);

export const hasGatewayId = (
  item: PaymentMethod
): item is PaymentMethodWithGateway =>
  typeof (item as any).gatewayID === 'number' &&
  !Number.isNaN((item as any).gatewayID);

export const flattenLeaves = (list: PaymentMethod[] = []): PaymentMethod[] =>
  list.flatMap((m) =>
    isGroup(m) ? flattenLeaves(m.paymentMethods || []) : [m]
  );

export const getFirstLeaf = (list: PaymentMethod[]): PaymentMethodLeaf | null =>
  (flattenLeaves(list).find(hasId) as PaymentMethodLeaf | undefined) ?? null;

export const findLeafById = (
  id: number,
  list: PaymentMethod[]
): PaymentMethodLeaf | null =>
  (flattenLeaves(list).find((m) => hasId(m) && m.id === id) as
    | PaymentMethodLeaf
    | undefined) ?? null;

export const resolveGatewayID = (
  selectedId: number | null | undefined,
  methods: PaymentMethod[]
): number | null => {
  if (selectedId == null) return null;
  const leaf = findLeafById(selectedId, methods);
  return leaf && hasGatewayId(leaf) ? leaf.gatewayID : null;
};
